import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewBannerComponent } from './components/preview-banner/preview-banner.component';
import { NbButtonModule, NbIconModule } from '@nebular/theme';
import { PreviewService } from './services/preview.service';
import { PreviewSessionService } from './services/preview-session.service';

@NgModule({
  declarations: [PreviewBannerComponent],
  imports: [CommonModule, NbIconModule, NbButtonModule],
  exports: [PreviewBannerComponent],
  providers: [PreviewService, PreviewSessionService],
})
export class PreviewModule {}
